import { Capacitor } from '@capacitor/core';

// True when running inside the Capacitor native shell (iOS app), false on web.
// Evaluated once at module load — the platform never changes within a session.
//
// Used to ship a CONSUMER-ONLY (B2C) app: the native build hides every B2B /
// salon-dashboard / admin / marketing surface, so the App Store binary is
// 100% client. The same bundle keeps all of it on web. See App.jsx (route
// gating), AppHeader / Footer (link removal), and the App Store compliance
// rationale (Guidelines 3.1.1 anti-steering + 4.2 minimum functionality).
export const isNativeApp = (() => {
  try { return Capacitor?.isNativePlatform?.() === true; } catch { return false; }
})();

// True only inside the native iOS shell. Some Capacitor plugins differ per
// platform (e.g. capgo social-login: iOS `login` REQUIRES an options object,
// Android must NOT get scopes), so a few call sites branch on this.
export const isIOS = (() => {
  try { return Capacitor?.getPlatform?.() === 'ios'; } catch { return false; }
})();

// BUILD-TIME product mode, orthogonal to the runtime platform check above.
// The "Petzy Business" binary is built with VITE_APP_MODE=business (see
// .env.business + `vite build --mode business`). It ships the SALON-DASHBOARD
// surface natively and hides the client marketplace — the mirror image of the
// default client app. Vite inlines import.meta.env at build time, so the web
// and client-native bundles compile this to false and are 100% unaffected.
export const isBusinessApp = import.meta.env.VITE_APP_MODE === 'business';

// The distinction that matters at every gate: `isNativeApp` alone used to mean
// BOTH "native platform" AND "consumer-only B2C app". Splitting them keeps
// true platform checks (plugins, API base, Turnstile) on `isNativeApp`, while
// the B2C route/link gating keys on `isClientNativeApp` — so the business
// binary re-includes the salon dashboard instead of stripping it.
export const isClientNativeApp = isNativeApp && !isBusinessApp;
